<div class="passport-details">
  <div class="separator"></div>
    <div class="detail-row">
      <span class="detail-label">Origin</span>
      <span class="detail-value" *ngIf="mode==='view'">{{ person?.origin || 'No Origin Field' }}</span>
    </div>
    <div class="detail-row" *ngIf="person?.haulier">
      <span class="detail-label">Haulier</span>
      <span class="detail-value" *ngIf="mode==='view'">{{ person?.haulier }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">Destination</span>
      <span class="detail-value" *ngIf="mode==='view'">{{ person?.destinationWeighbridge || person?.destination }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">APN/Name</span>
      <span class="detail-value" *ngIf="mode==='view'">{{ formattedApn }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">Vendor Number</span>
      <span class="detail-value" *ngIf="mode==='view'">{{ person?.vendorNumber }}</span>
    </div>
    <div class="detail-row">
      <span class="detail-label">Vendor Name</span>
      <span class="detail-value" *ngIf="mode==='view'">{{ person?.vendorName }}</span>
    </div>
    <div class="detail-row" *ngIf="!hidePassportComplete">
      <span class="detail-label">Passport Complete</span>
      <span class="detail-value" *ngIf="mode==='view'">{{ passportComplete }}</span>
    </div>

    <div class="separator"></div>
    <div class="actions" *ngIf="mode==='view'">
      <button class="btn btn-primary" type="button" (click)="add.emit()" *ngIf="!hideAdd">{{ primaryLabel }}</button>
      <button class="btn btn-outline white-bg" type="button" (click)="history.emit()">History</button>
      <button class="btn btn-outline white-bg" type="button" (click)="comments.emit()">Comments</button>
    </div>
</div>


